import { Helmet } from "react-helmet";
import { useEffect } from "react";
import ga from "../../googleAnalytics";
import "./booktime.css";
import homepagePic from "../../media/images/homepagePic.png";

export const BookTime = () => {
  useEffect(() => {
    //report to page view
    ga.trackPageView();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Helmi Helsinki | Ajanvaraus</title>
        <meta
          name="description"
          property="og:description"
          content="Varaa aikasi Helmi Helsinkiin täältä."
        ></meta>
        <meta property="og:title" content="Ajanvaraus" />
        <meta property="og:url" content="www.helmihelsinki.fi/booking" />
        <meta property="og:image" content={homepagePic} />
        <meta
          name="keywords"
          content="hairdresser, parturi, Make up, salon, Helsinki, Mikonkatu, kampaamo, website, ajanvaraus, booking, tidsbokning, parturikampaamo, hår, frisörtider, barberar tidsbokning, kampaamo ajanvaraus, ajat, vapaat ajat, vapaat ajat kampaamoon, hääkampaus, meikki, häämeikki, kampaus, hiustenleikkaus"
        />
      </Helmet>
      <div id="booktime-container">
        <iframe
          title="trima"
          height="800vh"
          width="100%"
          frameBorder="0"
          src="https://varaa.timma.fi/reservation/helmihelsinki"
          id="reservationIframe87681"
        ></iframe>
      </div>
    </div>
  );
};
